export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_poolparty-60dc330a95a1ebb3b3f986e8f312ddb9.jpg";